<template>
    <div>
        <UserTable />
    </div>
</template>

<script>
import UserTable from '@/components/user/UserTable.vue'
export default {
    components: {
        UserTable
    },
    name: 'Users'
}
</script>